import React, { Component } from 'react';
import TopMenuDropdown from './TopMenuDropdown';
import handleTrackingDropdown from './actions/handleTrackingDropdown';

export default class TopMenuItem extends Component {
    handleClick = (event, value) => {
        event.stopPropagation();
        this.props.handleItemClicks(value);
    }

    returnItem = (props) => {
        return (
            <div
              id={`item-${props.index}`}
              className="subitems show"
            >
                {props.subMenu.filter(item => item.online).map(item => (<a key={item.base_item_id} href={`/${item.slug}`}>{item.title}</a>))}
            </div>
        );
    }

    returnCustomItem = (props) => {
        return (
            <li role="presentation" className="item top-menu-items">
                <span className="nav-btn">
                    <a className="customTopMenuItem" href={`/${props.slug}`}>
                        {props.title}
                    </a>
                </span>
            </li>
        );
    }

    render() {
        if (this.props.subMenu.length === 0) return this.returnCustomItem(this.props);
        return (
            <li
              role="presentation"
              className={this.props.isOpen ? 'item top-menu-items -selected' : 'item top-menu-items'}
              onClick={e => this.handleClick(e, this.props.index)}
            >
                <span className="nav-btn" data-cta={handleTrackingDropdown(this.props.id)}>
                    {this.props.title}
                </span>
                {this.props.isOpen && this.returnItem(this.props)}
            </li>
        );
    }
}
